import { injectable } from 'inversify';
import { resolve } from '@/app/container';
import { EventStreamListener } from '@/app/event-stream/event-stream-listener';
import { AspectService, AspectServiceSymbol } from '@/app/aspect/aspect-service';
import { EventStream, EventStreamSymbol } from '@/app/event-stream/event-stream';
import {
  SectionInteractionEvent,
  StatisticsUpdatedEventName,
  SelectedChapterPercentUpdatedEventName, SelectedChapterPercentUpdated
} from '@/app/statistics/events/section-interaction-events';
import { SectionCompletion } from '@/app/statistics/section/section-progress';
import aspectStoreModule from '@/app/aspect/apsect-state';
import { createEvent } from '@/app/event-stream';

@injectable()
export class UpdateSelectedChapter implements EventStreamListener {
  // TODO: circular dependency - why?
  /*@inject(AspectServiceSymbol)
  private aspectService: AspectService;*/

  // TODO: circular dependency - why?
  /*@inject(EventStreamSymbol)
  private eventStream: EventStream;*/

  public get events(): string[] {
    return [
      StatisticsUpdatedEventName
    ];
  }

  public handle(event: SectionInteractionEvent): void {
    const completion: SectionCompletion = (event.payload as any).completion;
    const sectionId: string = completion.sectionId;
    const aspectService: AspectService = resolve<AspectService>(AspectServiceSymbol);
    aspectService.calculateSelectedChapter(sectionId, true).then(() => {
      if (aspectStoreModule.selectedChapter !== null) {
        const eventStream: EventStream = resolve<EventStream>(EventStreamSymbol);
        const updatedEvent = createEvent<typeof SelectedChapterPercentUpdatedEventName, SelectedChapterPercentUpdated>(
          SelectedChapterPercentUpdatedEventName,
          {
            sectionId,
            selectedChapter: aspectStoreModule.selectedChapter
          }
        );
        eventStream.dispatch(updatedEvent);
      }
    });
  }
}
